import {Component, OnInit, inject} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

export interface ThaidAuthData {
  pid: string;
  givenName: string;
  middleName: string;
  familyName: string;
  displayName: string;
}

@Component({
  selector: 'app-thaid-callback',
  standalone: true,
  template: `
    <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100vh;font-family:sans-serif;gap:16px">
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="#198754" viewBox="0 0 16 16">
        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
      </svg>
      <p style="color:#198754;font-size:1.1rem;margin:0">ยืนยันตัวตนสำเร็จ</p>
      <p style="color:#666;font-size:.9rem;margin:0">กรุณาปิดหน้าต่างนี้</p>
      <button onclick="window.close()" style="margin-top:8px;padding:8px 20px;border:1px solid #ccc;border-radius:6px;background:#fff;cursor:pointer">
        ปิดหน้าต่าง
      </button>
    </div>
  `
})
export class ThaidCallbackComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);

  ngOnInit(): void {
    const p = this.route.snapshot.queryParams;
    const givenName = p['given_name'] ?? '';
    const middleName = p['middle_name'] ?? '';
    const familyName = p['family_name'] ?? '';
    const displayName = [givenName, middleName, familyName].filter(Boolean).join(' ');

    const data: ThaidAuthData = {
      pid: p['pid'] ?? '',
      givenName,
      middleName,
      familyName,
      displayName,
    };

    const channel = new BroadcastChannel('thaid-auth');
    channel.postMessage({type: 'THAID_AUTH_SUCCESS', payload: data});
    channel.close();

    window.close();
  }
}
